module.exports = __webpack_public_path__ + "static/img/1.cd84e11.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/gongzhumanghe/1.png
// module id = y+VS
// module chunks = 1